import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";

// Admin is code-split so public visitors never download the dashboard bundle.
const Admin = lazy(() => import("@/pages/Admin"));

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/admin"
            element={
              <Suspense fallback={<div data-testid="admin-loading" className="min-h-screen bg-background" />}>
                <Admin />
              </Suspense>
            }
          />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors={false} />
    </div>
  );
}

export default App;
